var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "icon Twitter",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 35 35"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 353",
    cx: 17.5,
    cy: 17.5,
    r: 17.5,
    fill: "#999590"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.033 10.937a7.769 7.769 0 01-.991.361 4.382 4.382 0 00.892-1.569.331.331 0 00-.484-.385 7.8 7.8 0 01-2.306.911 4.4 4.4 0 00-7.48 3.148 4.489 4.489 0 00.036.569 11.265 11.265 0 01-7.732-4.1.331.331 0 00-.542.042 4.407 4.407 0 00.451 5.065 3.727 3.727 0 01-.589-.263.331.331 0 00-.491.281v.059a4.416 4.416 0 002.154 3.784 3.466 3.466 0 01-.335-.049.331.331 0 00-.377.426 4.4 4.4 0 003.223 2.945 7.785 7.785 0 01-4.16 1.187 7.96 7.96 0 01-.932-.055.331.331 0 00-.218.609 11.867 11.867 0 006.417 1.881 11.416 11.416 0 008.845-3.885 12.313 12.313 0 003.065-8.025c0-.121 0-.243-.006-.364a8.554 8.554 0 001.969-2.087.331.331 0 00-.409-.486z",
    fill: "#fff"
  })));
}
export default SvgTwitter;